<template>
  <!-- 低分高分模式显示 ... -->
  <div>
    <div class="detail table">
      <table
        v-for="(lvs, index) in this.levels"
        :key="index"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="table-box"
        :class="{ tablesplit: index > 0 }"
      >
        <col style="width: 40px" />
        <col style="width: 125px" />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col style="width: 125px" />
        <tr class="td-head" v-if="index == 0">
          <th style="width: 40px">维度</th>
          <th style="width: 125px">低分特征</th>
          <th colspan="10">得分</th>
          <th style="width: 125px">高分特征</th>
        </tr>
        <tbody class="table-tbody">
          <tr v-if="index != 0 && isPdf">
            <td colspan="13" style="height: 30px">&nbsp;</td>
          </tr>
          <tr v-for="(item, index) in lvs" :key="index">
            <td
              width="30px"
              style="background: #69c5ef; padding: 10px 0px 10px 0px"
              v-if="item.name == '身体状态' || item.name == '精力充沛'"
            >
              <div class="name">{{ item.name }}</div>
            </td>

            <td
              width="30px"
              style="background: #eb766e; padding: 10px 0px 10px 0px"
              v-if="
                item.name == '情绪稳定性' ||
                item.name == '抑郁程度' ||
                item.name == '焦虑程度'
              "
            >
              <div class="name">{{ item.name }}</div>
            </td>

            <td
              width="30px"
              style="background: #f6b350; padding: 10px 0px 10px 0px"
              v-if="
                item.name == '乐观积极' ||
                item.name == '进取性' ||
                item.name == '自信心' ||
                item.name == '持之以恒'
              "
            >
              <div class="name">{{ item.name }}</div>
            </td>

            <td
              width="30px"
              style="background: #a3d46c; padding: 10px 0px 10px 0px"
              v-if="item.name == '偏执性' || item.name == '精神状态'"
            >
              <div class="name">{{ item.name }}</div>
            </td>

            <td
              width="30px"
              style="background: #8982e8; padding: 10px 0px 10px 0px"
              v-if="
                item.name == '亲切随和' ||
                item.name == '合群性' ||
                item.name == '外向性'
              "
            >
              <div class="name">{{ item.name }}</div>
            </td>

            <td
              width="30px"
              style="background: #8799a3; padding: 10px 0px 10px 0px"
              v-if="
                item.name == '社会适应' ||
                item.name == '应对方式' ||
                item.name == '忍耐挫折'
              "
            >
              <div class="name">{{ item.name }}</div>
            </td>
            <td width="30px" style="background: #f3f4f8; padding: 10px">
              {{ item.low }}
            </td>
            <td
              width="30px"
              style="background: #ffb8b8; color: white; text-align: center"
            >
              <span>1</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 1 || item.score == 1"
            >
              <span>2</span>
            </td>
            <td
              width="30px"
              style="background: #ffb8b8; color: white; text-align: center"
              v-if="item.score > 1 || item.score == 2"
            >
              <span>2</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 2 || item.score == 2"
            >
              <span>3</span>
            </td>

            <td
              width="30px"
              style="background: #ffb8b8; color: white; text-align: center"
              v-if="item.score > 2 || item.score == 3"
            >
              <span>3</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 3 || item.score == 3"
            >
              <span>4</span>
            </td>

            <td
              width="30px"
              style="background: #ffc2b0; color: white; text-align: center"
              v-if="item.score > 3 || item.score == 4"
            >
              <span>4</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 4 || item.score == 4"
            >
              <span>5</span>
            </td>

            <td
              width="30px"
              style="background: #ffc2b0; color: white; text-align: center"
              v-if="item.score > 4 || item.score == 5"
            >
              <span>5</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 5 || item.score == 5"
            >
              <span>6</span>
            </td>

            <td
              width="30px"
              style="background: #ffc2b0; color: white; text-align: center"
              v-if="item.score > 5 || item.score == 6"
            >
              <span>6</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 6 || item.score == 6"
            >
              <span>7</span>
            </td>

            <td
              width="30px"
              style="background: #ffc2b0; color: white; text-align: center"
              v-if="item.score > 6 || item.score == 7"
            >
              <span>7</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 7 || item.score == 7"
            >
              <span>8</span>
            </td>

            <td
              width="30px"
              style="background: #b8e8e8; color: white; text-align: center"
              v-if="item.score > 7 || item.score == 8"
            >
              <span>8</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 8 || item.score == 8"
            >
              <span>9</span>
            </td>

            <td
              width="30px"
              style="background: #b8e8e8; color: white; text-align: center"
              v-if="item.score > 8 || item.score == 9"
            >
              <span>9</span>
            </td>

            <td
              width="30px"
              style="background: #f3f4f8; color: #6b6b6a; text-align: center"
              v-if="item.score < 9 || item.score == 9"
            >
              <span>10</span>
            </td>

            <td
              width="30px"
              style="background: #b8e8e8; color: white; text-align: center"
              v-if="item.score > 9 || item.score == 10"
            >
              <span>10</span>
            </td>

            <td style="background: #f3f4f8; padding: 10px">{{ item.high }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { pageFour } from "@/views/report/config/three";
export default {
  props: ["result", "level2"],
  data() {
    return {
      values: pageFour.SectionviewData,
      colors: [
        {
          name: "工作倦怠",
        },
      ],
      new: [],
      levels: [],
      realScore: [],
      isPdf: false,

      resHeight: [
        { name: "身体状态", height: 150 },
        { name: "精力充沛", height: 108 },
        { name: "情绪稳定性", height: 128 },
        { name: "抑郁程度", height: 108 },
        { name: "焦虑程度", height: 108 },
        { name: "乐观积极", height: 108 },
        { name: "进取性", height: 88 },
        { name: "自信心", height: 108 },
        { name: "持之以恒", height: 108 },
        { name: "偏执性", height: 108 },
        { name: "精神状态", height: 108 },
        { name: "亲切随和", height: 108 },
        { name: "合群性", height: 108 },
        { name: "外向性", height: 108 },
        { name: "忍耐挫折", height: 108 },
        { name: "应对方式", height: 108 },
        { name: "社会适应", height: 108 },
      ],
    };
  },
  watch: {
    level2(val) {
      // this.level2 = val;
      this.panduan(val);
    },
  },
  mounted() {
    if (location.hash.indexOf("pdf") > -1) {
      this.isPdf = true;
    }
    this.panduan(this.level2);
  },
  methods: {
    //内容显示830px
    panduan(les) {
      let arr = [];
      let result = [];
      if (les.filter((item) => item.length > 0)) {
      }
      if (les && les.length > 0) {
        let nowHeight = 385;
        les.map((item, index) => {
          // console.log("图", item.score);
          let hasItem = this.resHeight.filter((r) => r.name == item.name);
          if (hasItem.length > 0) {
            let itemBottom = nowHeight + hasItem[0].height + 8;
            // console.log(item.name, 'now hieght', itemBottom)
            let nextBottom = itemBottom;
            if (
              les[index + 1] &&
              this.resHeight.filter((r) => r.name == les[index + 1].name)
                .length > 0
            ) {
              nextBottom +=
                this.resHeight.filter((r) => r.name == les[index + 1].name)[0]
                  .height + 8;
              // console.warn(item.name, 'next hieght', nextBottom)
            }
            arr.push(item);
            //如果加上，下一个的高度大于1124，则此项高度单独设置
            if (nextBottom > 1124) {
              result.push(arr);
              arr = [];
              nowHeight = 0;
              // console.warn(item.name, 'split height', nowHeight)
            } else {
              nowHeight = itemBottom;
            }
          }
        });
        if (arr.length > 0) {
          result.push(arr);
        }

        this.levels = result;
      }
      // console.log("this.jiaocha", this.jiaocha);
      // console.log("this.chabuduo", this.chabuduo);
      // console.log("this.levels", );
    },
  },
};
</script>

<style scoped>
.table-box {
  text-align: justify;
  font-size: 10pt;
  width: 90%;
  margin-left: 40px;
  margin-right: 40px;
  border-collapse: separate;
  border-spacing: 4px;
}
.table-box.tablesplit {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
}
.name {
  /* padding: 20px; */
  width: 20px;
  margin: 0 auto;
  line-height: 20px;
  color: white;
  font-size: 14px;
  text-align: center;
  padding: 2px;
  /* color: white; */
}
.table {
  padding: 30px 0px 0px;
}
.table tr th {
  text-align: center;
  line-height: 30px;
}
.table tr td {
  line-height: 21px;
  background: #fff;
}
/* .table.speTable tr td:first-child {
  width: 35%;
} */
/* table {
  width: 550px;
} */
table tr.td-head td,
table tr.td-head th {
  font-weight: bold;
  padding: 5px;
  background: #e4e6ec;
  /* line-height: 35px; */
  color: #333;
  font-size: 13px;
}
table tr td {
  padding: 0px 0px;
  background: #fff;
}
.teamWorkTable table tr td.top {
  padding: 4px 0px;
}
table tr td.backtd {
  background: rgba(226, 240, 217, 1);
}
.table tr td.tl {
  text-align: left;
}
.table tr td li:before {
  content: " √ ";
}
.detail table tr td {
  font-size: 12px;
}
.detail table tr td:first-child {
  font-weight: bold;
  font-size: 12px;
}
.table tr td.rageBack {
  background: #dedede;
  text-align: center;
}
.table tr td span.isValue {
  display: block;
  background: #333;
  width: 8px;
  height: 8px;
  border-radius: 9px;
  margin: 0px auto;
}
.teamWorkTable tr td {
  text-align: center;
}
.teamWorkTable .top td {
  background: #000080;
  color: #fff;
  font-size: 12px;
  padding: 4px 0px;
}
.teamWorkTable tr td.left {
  background: #999;
}
.pf16ValuesTable tr td {
  font-size: 12px;
}
.detail table tr td.middle {
  width: 30px;
  background: #dedede;
}
td .yuandian {
  font-size: 16px;
  color: #000080;
  font-family: Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/table/three/lowHighScore.vue